import { IntlShape } from "react-intl";

export const generateTimeString = (
  workingTime: {
    monday: string[];
    tuesday: string[];
    wednesday: string[];
    thursday: string[];
    friday: string[];
    saturday: string[];
    sunday: string[];
    exceptions: string[];
  },
  formatMessage: IntlShape["formatMessage"]
): string => {
  const dayMap: { key: keyof typeof workingTime; label: string }[] = [
    { key: "monday", label: "working_days.mon" },
    { key: "tuesday", label: "working_days.tue" },
    { key: "wednesday", label: "working_days.wed" },
    { key: "thursday", label: "working_days.thu" },
    { key: "friday", label: "working_days.fri" },
    { key: "saturday", label: "working_days.sat" },
    { key: "sunday", label: "working_days.sun" },
    { key: "exceptions", label: "working_days.exceptions" }
  ];

  const hoursArr = dayMap
    .filter(({ key }) => workingTime[key]?.[0])
    .map(({ key, label }) => `${formatMessage({ id: label })}: ${workingTime[key].join(" - ")}`);

  return hoursArr.join(" &nbsp; ");
};
